import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogActions } from '@angular/material/dialog';
import { Aplicacion } from 'src/app/shared/model/fise/aplicacion.model';
import { Servidor } from 'src/app/shared/model/fise/servidor.model';


import swal from 'sweetalert2';
import { FiseService } from '../../fise.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatError, MatLabel } from '@angular/material/input';
import { SoloLetraEspacioNumeroAcentoDirective } from '../../../utilerias/directives/solo-letra-espacio-numero-acento.directive';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-modal-aplicacion',
    standalone: true,
    templateUrl: './modal-aplicacion.component.html',
    styleUrls: ['./modal-aplicacion.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatLabel, SoloLetraEspacioNumeroAcentoDirective, NgIf, MatError, MatDialogActions, MatButton]
})
export class ModalAplicacionComponent implements OnInit {
  formGroupAplicacion: FormGroup;
  tituloOperacion: string;
  objectAplicacion: Aplicacion;
  listaIp: Array<Servidor>;
  constructor( public modalDialog: MatDialogRef<ModalAplicacionComponent>,
    @Inject(MAT_DIALOG_DATA) public aplicacionEdit: Aplicacion,
    private formBuildier: FormBuilder, private aplicacionService: FiseService,
    private cdref: ChangeDetectorRef) { }
    taskTypeAreas:any[];
    selectedOptions: any[];
    get formAplicacion() {return this.formGroupAplicacion.controls;}
  ngOnInit() {
    if(this.aplicacionEdit.id == null ){
      this.tituloOperacion = "Alta"
    }else{
      this.tituloOperacion = "Edición";
    }
    this.objectAplicacion = this.aplicacionEdit;


    this.formGroupAplicacion = this.formBuildier.group({
      controlIp: ['', [Validators.required]],
      controlNaplicacion: ['', [Validators.required,  Validators.minLength(1)]],
      controlVersion: ['', [Validators.required,  Validators.minLength(1)]],
      controlDescripcion: ['', []]
     });
    
   
     
  

    }

  onClicCerrarModal(): void {
    this.modalDialog.close();
  }

onClicGuardar(): void {
   
    this.aplicacionService.GuaradarOActualizarApp(this.objectAplicacion).subscribe(response => {
         if(response.pCodRetorno === '00000')
          this.modalDialog.close(response.pCodRetorno);
        swal.fire({
          title: response.pCodRetorno === '00000' ? 'ÉXITO' : 'ERROR',
          text: response.pMensaje,
          buttonsStyling: false,
          customClass:{
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-info',
          },
          confirmButtonText: 'Aceptar',
          icon: response.pCodRetorno === '00000' ? 'success' : 'warning'
        }).then(responseMsG => {
        })
    });
   
}

}
